import axios from 'axios';
import { TOKEN_PREFIX } from '../config/config'

/**
 * setAuthToken constant function (verify if token exists and set this to axios Authorization header and localStorage Token,
 * else, remove axios authorization header and localStorage Token)
 *  
 * @export constant
 * @param {*} token
 * @returns boolean
 */
const setAuthToken = (token, roleName = localStorage.getItem('role'), type = localStorage.getItem('type')) => {
    if (token) {
        axios.defaults.headers['Authorization'] = TOKEN_PREFIX+token;
        localStorage.setItem('jwtToken', TOKEN_PREFIX+token);
        localStorage.setItem('role', roleName );
        localStorage.setItem('type', type );
    } else {
        delete axios.defaults.headers['Authorization'];
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('role');
        localStorage.removeItem('currentClientID');
        localStorage.removeItem('type');
    }
};

export default setAuthToken;
